import InvoiceList from '../../views/Invoice/InvoiceList';

export default [
    {
        path: '/faturas',
        name: 'invoice.list',
        component: InvoiceList,
        meta: {
            pageTitle: 'Faturas',
            breadcrumb: [
                { label: 'Faturas' },
            ],
        },
    }
];
